import { render, staticRenderFns } from "./lesson_channel.vue?vue&type=template&id=67f6a8b2&scoped=true"
import script from "./lesson_channel.vue?vue&type=script&lang=js"
export * from "./lesson_channel.vue?vue&type=script&lang=js"
import style0 from "./lesson_channel.vue?vue&type=style&index=0&id=67f6a8b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f6a8b2",
  null
  
)

export default component.exports